<template>
	<div class="collapse w-full">
		<div class="collapse-selection-container">

			<!-- Mobile: Using select for item selection -->
			<div class="tabs mb-8 md:mb-12">
				<button v-for="(item, index) in collapseItems"
						:aria-pressed="currentItemIndex === index"
						v-on:click="currentItemIndex = index">
					<span class="number">{{ pad(index + 1, 2) }}</span>
					<span class="name">{{ item.title }}</span>
				</button>
			</div>

			<div class="collapse-selection">
				<div
						v-for="(item, index) in collapseItems"
						:key="item.title"
						class="collapse-selector"
						:class="{ 'active': currentItemIndex === index }">
					<div class="card-layout card-content" @click="currentItemIndex = index">
						{{ item.title }}
					</div>
				</div>
			</div>
		</div>

		<div class="collapse-item-content-wrapper">

			<div
					v-for="(item, index) in collapseItems"
					:key="item.id"
					v-html="item.text"
					class="collapse-item-content bard sub-bard"
					:class="{ 'active': currentItemIndex === index }">
			</div>

		</div>

	</div>

</template>

<script>
import {uuid} from '../customer/uuid';

const inView = require('in-view');
import anime from 'animejs';
import {BREAKPOINT_LG} from '../globals';

export default {
	props: {
		items: {
			type: String
		}
	},
	data() {
		return {
			collapseItems: {},
			currentItemIndex: 0
		};
	},
	methods: {
		pad: (number, digits) => {
			number = String(number);
			return number.length >= digits ? number : new Array(digits - number.length + 1).join('0') + number;
		},
		initialAnim: function() {
			const reducedMotionMatch = window.matchMedia("(prefers-reduced-motion: reduce)");

			if (reducedMotionMatch && !reducedMotionMatch.matches) {
				this.$el.setAttribute('data-collapse', uuid());
				this.$el.style.visibility = 'hidden';

				inView(`.bard__module.collapse .collapse[data-collapse="${this.$el.getAttribute('data-collapse')}"]`).once('enter', () => {
					const selector = window.innerWidth < BREAKPOINT_LG ?
							this.$el.querySelector('.collapse-selection-compact') :
							this.$el.querySelectorAll('.collapse-selector');

					anime.timeline()
							.add({
								targets: selector,
								opacity: [0, 1],
								easing: 'easeOutSine',
								duration: 500,
								delay: (el, i) => 500 + 50 * i
							})
							.add({
								targets: this.$el.querySelector('.collapse-item-content-wrapper'),
								translateX: [-40, 0],
								opacity: [0, 1],
								easing: 'easeOutSine',
								duration: 500,
								delay: 0
							});

					this.$el.style.visibility = 'visible';
				});
			}
		}
	},
	mounted: function () {
		this.collapseItems = JSON.parse(this.items);

		this.initialAnim();
	}
};
</script>
